import { StorageService } from "../StorageService";
import { STORAGE_KEYS } from "../storageKeys";
import { UserProfile } from "../../../types/userProfile";

export const DEFAULT_USER_PROFILE: UserProfile = {
  id: "guest_visitor",
  name: "Visitante (Não Conectado)",
  email: "",
  phone: "",
  pixKey: "",
  accountType: "atleta",
  city: "",
  state: "",
  preferredSports: ["Beach Tennis", "Futevôlei"],
  createdAt: Date.now(),
};

export class UserProfileRepository {
  public static getStorageKeyForUser(userKey?: string): string {
    if (!userKey || userKey === "guest_visitor") {
      return STORAGE_KEYS.USER_PROFILE_ACTIVE;
    }
    const sanitized = userKey.replace(/[^a-zA-Z0-9_@.-]/g, "_");
    return `${STORAGE_KEYS.USER_PROFILE_PREFIX}${sanitized}`;
  }

  public static getActiveProfile(): UserProfile | null {
    return StorageService.get<UserProfile>(STORAGE_KEYS.USER_PROFILE_ACTIVE, null);
  }

  public static getProfile<T = UserProfile>(): T | null {
    return StorageService.get<T>(STORAGE_KEYS.USER_PROFILE_ACTIVE, null);
  }

  public static setActiveProfile(profile: UserProfile): void {
    StorageService.set(STORAGE_KEYS.USER_PROFILE_ACTIVE, profile);
  }

  public static getProfileByKey(userKey: string): UserProfile | null {
    const key = this.getStorageKeyForUser(userKey);
    return StorageService.get<UserProfile>(key, null);
  }

  public static setProfileByKey(userKey: string, profile: UserProfile): void {
    const key = this.getStorageKeyForUser(userKey);
    StorageService.set(key, profile);
  }

  public static clearProfilesOnLogout(): void {
    StorageService.remove(STORAGE_KEYS.USER_PROFILE_ACTIVE);
    StorageService.remove(STORAGE_KEYS.USER_PROFILE_LEGACY_1);
    StorageService.remove("arena_esportes_user_profile_v2");

    // Limpa todas as chaves dinâmicas com prefixos de perfis de usuário
    StorageService.clearByPrefix(STORAGE_KEYS.USER_PROFILE_PREFIX);
    StorageService.clearByPrefix(STORAGE_KEYS.APP_USER_PROFILE_PREFIX);
  }
}
